import { AudioService } from './../../services/audio.service';
/*
  https://stackblitz.com/edit/mat-dialog-example

  openDialog() {
    const dialogRef = this.dialog.open(ConfirmationDialog, {
      data: {
        icon: '..', // (?)='help'
        message: 'Dialog prompt to user',

        // buttons array may be used to define multiple buttons with all options, rendered right to left
        buttons: [
          { icon: 'install_desktop', text: 'OK', color: 'primary', value: true },
          { text: 'Cancel' },
        ],

        // for simple 2-button confirmation may omit buttons:[] and replace button label text simply with...
        confirmText: 'Yep',
        cancelText: 'Nope',

      }
    });

    dialogRef.afterClosed().subscribe(button_value => {
      if (button_value) { ... }
    });
  }
*/

import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Sound } from 'src/app/services/audio.service';

export interface ConfirmationDialogData {
  icon?: string,
  message?: string,
  buttons?: DialogButton[]
  confirmText?: string,
  cancelText?: string,
  sound?: Sound
}

@Component({
  selector: 'confirmation-dialog',
  templateUrl: 'confirmation-dialog.component.html',
})
export class ConfirmationDialog {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ConfirmationDialogData,
    public dialogRef: MatDialogRef<ConfirmationDialog>,
    private audio: AudioService
  ) {
    this.data = {
      ...{
        sound: undefined,
        message: 'Are you sure?',
        buttons: [
          {
            text: this.data?.cancelText || 'Cancel'
          },
          {
            text: this.data?.confirmText || 'Yes',
            color: 'primary',
            value: true
          }
        ]
      },
      ...(this.data || {})
    }

    this.dialogRef.afterOpened().subscribe(() => {
      if (this.data.sound) this.audio.play(this.data.sound);
    });
  }

  buttonClick(button: DialogButton) {
    button.text = button.value;
    this.dialogRef.close(button.value);
  }
}

interface DialogButton {
  text: string,
  icon?: string,
  color?: string,
  value?: any
}